import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app";
import Providers from "./Providers/Providers";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Providers>
    <App />
  </Providers>,
);
